import { render, staticRenderFns } from "./CustomerTabLinks.vue?vue&type=template&id=0a6dbb1a"
import script from "./CustomerTabLinks.vue?vue&type=script&lang=js"
export * from "./CustomerTabLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports